import { InsuranceTrigger } from './Trigger'
import { InsuranceContent } from './Content'

const InsuranceAlert = {
  Trigger: InsuranceTrigger,
  Content: InsuranceContent,
}

export { InsuranceAlert }
